import { useSilaeVariables } from "@/hooks/useSilaeVariables";

/**
 * Composant pour charger les variables Silae au démarrage de l'application
 * Ce composant ne rend rien, il charge simplement les variables en arrière-plan
 * Le chargement est géré automatiquement par le hook useSilaeVariables
 */
export const SilaeVariablesLoader: React.FC = () => {
  // Le simple fait d'appeler le hook déclenche le chargement automatique
  // via le useEffect dans useSilaeVariables
  useSilaeVariables();

  // Ce composant ne rend rien
  return null;
};
